/**
 * Forms.
 * 
 */

/**
 * Forms built via WPForms plugin.
 * 
 */

function initFormTextElements($scopeEl) {
	console.log("initFormTextElements()");
    
    // Add marker class to any fields that are not empty
    let fieldTypes = 'input[type="text"], input[type="email"], textarea, select';
    let $elements = ($scopeEl !== null) ? $scopeEl.find(fieldTypes) : $(fieldTypes);

	console.dir($elements);

    // Run an initial check...
    $.each($elements, (index, el) => {
        checkForEmpty($(el));
    });
    // Then set up a listener for any changes to the fields
    $elements.on('input propertychange paste', (evt) => {
        checkForEmpty($(evt.target));
    });

    function checkForEmpty($el) {
        // console.log($el.attr('class'));
        // console.log($el.val());
        if (($el.val() !== '') && ($el.val() !== null)) {
            $el.parent().addClass('is-not-empty');
        } else {
            $el.parent().removeClass('is-not-empty');
        }
    }
}

exports.init = function () {
    // Run init methods...
    initFormTextElements($('.form-side__form-wrap.wp-form'));
};